import allCountries from '@/helpers/countries'
import type { Currency } from '@caterdesk/utils--money'

export const DEFAULT_CURRENCY = 'GBP' as const

/**
 * Get a common price formatter for the specific locale.
 *
 * @param locale The locale we want to format the price in.
 *
 * @returns The Intl.NumberFormat instance to format a price.
 */
export function getPriceFormatter(locale: string): Intl.NumberFormat {
  let currency: Currency | (string & NonNullable<unknown>) = DEFAULT_CURRENCY

  if (locale) {
    const country = allCountries.find((c) => c.locales.includes(locale.toLowerCase()))
    currency = country?.currency || DEFAULT_CURRENCY
  }

  const formatter = new Intl.NumberFormat(locale || 'en-GB', {
    style: 'currency',
    currency,
    currencySign: 'standard',
    currencyDisplay: 'narrowSymbol',
    trailingZeroDisplay: 'auto',
    maximumFractionDigits: 2,
  })

  return formatter
}
